import Email from './email/Email';
import oauth from 'components/auth/login/integrations/oauth';
import RegisterAnnoyingComponent from './imported-id/Register';

export default {
	email: Email,
	imported_id: RegisterAnnoyingComponent,
	...oauth,
};
